/*
  Losse kaarten. Twee delen:

  1. De kaart (snippets/cardify-single-kaart.liquid), op de setpagina en in het
     singles-overzicht. Kiest iemand een andere uitvoering, dan zetten we prijs,
     voorraadregel, de plus en de teller op die variant. De plus is een gewone
     data-cf-add-knop van de eigen winkelmand (cardify-cart.js). Die mand onthoudt regels
     op id; daarom draagt de plus de variant-id als id, anders vallen Holo en Reverse holo
     van dezelfde kaart samen in een regel. Of de teller of de plus zichtbaar is, beslist
     de mand (kaartTellers); na een wissel kijken we zelf in dezelfde opslag ("cf-mand").

  2. "Alleen wat ik mis" op de setpagina. Leest dezelfde browseropslag als de vinkjes op
     de kaartenlijst van de set (cardify-collectie.js), sleutel
     cardify:collectie:v1:<set-slug>. Er gaat niets naar ons of naar een account. Heeft
     iemand op deze set nog niets aangevinkt, dan blijft het blok weg. Verbergen gaat via
     data-cf-uit, net als op de kaartenlijst. Nooit via hidden. ?mis=1 in de URL zet de
     stand meteen aan.

  Filterpaneel en sorteren doet cardify-singles-overzicht.js, op beide pagina's.
*/
(function () {
  'use strict';

  function taal() {
    return (window.CardifyI18n && window.CardifyI18n.taal) === 'en' ? 'en' : 'nl';
  }
  function zetTekst(el, nl, en) {
    el.setAttribute('data-nl', nl);
    el.setAttribute('data-en', en);
    el.textContent = taal() === 'en' ? en : nl;
  }
  function inMand(id) {
    try {
      var m = JSON.parse(localStorage.getItem('cf-mand') || '[]');
      for (var i = 0; i < m.length; i++) if (String(m[i].id) === String(id)) return m[i];
    } catch (e) {}
    return null;
  }

  // ---- 1. De kaart: uitvoering kiezen ----
  document.addEventListener('click', function (e) {
    var keuze = e.target.closest('[data-cf-sk-v]');
    if (!keuze) return;
    var kaart = keuze.closest('[data-cf-sk]');
    var id = keuze.getAttribute('data-id');
    kaart.querySelectorAll('[data-cf-sk-v]').forEach(function (b) {
      b.setAttribute('aria-checked', String(b === keuze));
    });

    var prijs = kaart.querySelector('[data-cf-sk-prijs]');
    if (prijs) prijs.textContent = keuze.getAttribute('data-prijs-tekst');

    var q = parseInt(keuze.getAttribute('data-voorraad'), 10) || 0;
    var regel = kaart.querySelector('[data-cf-sk-voorraad]');
    var stip = kaart.querySelector('[data-cf-sk-stip]');
    if (regel) {
      if (q === 1) zetTekst(regel, 'Laatste exemplaar', 'Last one');
      else if (q > 1) zetTekst(regel, q + ' op voorraad', q + ' in stock');
      else zetTekst(regel, 'Op voorraad', 'In stock');
    }
    if (stip) stip.classList.toggle('is-laatste', q === 1);

    var plus = kaart.querySelector('[data-cf-sk-knop]');
    if (plus) {
      plus.setAttribute('data-id', id);
      plus.setAttribute('data-variant', id);
      plus.setAttribute('data-prijs', keuze.getAttribute('data-prijs'));
      plus.setAttribute('data-naam', keuze.getAttribute('data-naam'));
    }
    var actie = kaart.querySelector('[data-cf-teller]');
    if (actie) {
      actie.setAttribute('data-cf-teller', id);
      actie.querySelectorAll('[data-cf-min],[data-cf-plus]').forEach(function (b) { b.setAttribute('data-id', id); });
      var teller = actie.querySelector('.cf-kaart-teller');
      var r = inMand(id);
      if (plus) plus.hidden = !!r;
      if (teller) {
        teller.hidden = !r;
        if (r) teller.querySelector('[data-cf-teller-aantal]').textContent = r.qty;
      }
    }
  });

  // ---- 2. Alleen wat ik mis (setpagina) ----
  var wrap = document.querySelector('[data-cf-singles]');
  if (!wrap) return;

  var slug = wrap.getAttribute('data-cf-set') || '';
  var kaarten = Array.prototype.slice.call(document.querySelectorAll('[data-cf-single]'));
  // Na direct filteren (cardify-singles-overzicht.js) staan er nieuwe kaarten; die opnieuw ophalen.
  document.addEventListener('cf:so-nieuw', function () { kaarten = Array.prototype.slice.call(document.querySelectorAll('[data-cf-single]')); if (aan) pasToe(); });
  var blok = document.querySelector('[data-cf-mis-blok]');
  var knop = document.querySelector('[data-cf-mis-knop]');
  var teller = document.querySelector('[data-cf-mis-teller]');

  var bezit = {};
  if (slug) {
    try {
      var rauw = localStorage.getItem('cardify:collectie:v1:' + slug);
      var o = rauw ? JSON.parse(rauw) : {};
      if (o && typeof o === 'object' && !Array.isArray(o)) bezit = o;
    } catch (e) { bezit = {}; }
  }

  var aan = false;
  function pasToe() {
    var zichtbaar = 0;
    kaarten.forEach(function (k) {
      var nr = k.getAttribute('data-cf-nr') || '';
      if (aan && nr && bezit[nr]) k.setAttribute('data-cf-uit', '');
      else { k.removeAttribute('data-cf-uit'); zichtbaar++; }
    });
    if (knop) {
      knop.classList.toggle('is-actief', aan);
      knop.setAttribute('aria-pressed', String(aan));
    }
    if (teller) teller.textContent = taal() === 'en' ? zichtbaar + ' cards shown' : zichtbaar + ' kaarten in beeld';
  }

  if (blok && Object.keys(bezit).length > 0 && kaarten.length) {
    blok.hidden = false;
    if (/[?&]mis=1(&|$)/.test(location.search)) aan = true;
    knop.addEventListener('click', function () { aan = !aan; pasToe(); });
    document.addEventListener('cf:taal', pasToe);
    pasToe();
  }
})();
